import { createSelector } from 'reselect';
import { selectBonusOffersNotQualifiedAndActiveFormatted } from 'core/modules/BonusOffers/selectors';

import config from '../configs';

const { offersLimit } = config;

// Render only a limited amount of ofers on some pages
export const selectBonusOffers = createSelector(
  selectBonusOffersNotQualifiedAndActiveFormatted,
  bonusOffersValidFormatted => (
    offersLimit ? bonusOffersValidFormatted.slice(0, offersLimit) : bonusOffersValidFormatted
  ),
);
